import moment from "moment";
import 'moment/locale/es';

export function formatDate(value) {
  if (value) {
    const myDate = new Date(value);
    const dd = myDate.getUTCDate();
    const mm = myDate.getUTCMonth();
    const yyyy = myDate.getUTCFullYear();

    const dateFormat = moment(new Date(yyyy, mm, dd)).format("DD/MM/YYYY");

    return dateFormat;
  }
}


export function formatDateMMYYYY(value) {
  if (value) {
    const myDate = new Date(value);
    const dd = myDate.getUTCDate();
    const mm = myDate.getUTCMonth();
    const yyyy = myDate.getUTCFullYear();

    const dateFormat = moment(new Date(yyyy, mm, dd)).format("MM/YYYY");
    console.log("dateFormat:" + dateFormat);
    return dateFormat;
  }
}

export function formatDateMonthYYYY(value) {
  if (value) {
    const myDate = new Date(value);
    const dd = myDate.getUTCDate();
    const mm = myDate.getUTCMonth();
    const yyyy = myDate.getUTCFullYear();

    const locale = 'es-ES'; 
      
      // 2. Definimos las opciones de formato:
      const options = {
        month: 'long', // Para obtener el nombre completo del mes (ej: "noviembre")
        year: 'numeric'  // Para obtener el año completo (ej: "2025")
      };

      // 3. Creamos el formateador y lo aplicamos a la fecha
      return new Intl.DateTimeFormat(locale, options).format(new Date(yyyy, mm, dd));


//    const dateFormat = moment(new Date(yyyy, mm, dd)).locale('es').format("MMMM/YYYY");
//    console.log("dateFormat:" + dateFormat);
//    return dateFormat;
  }
}


export function formatDatetoUsDate(value) {
  if (value) {
    const myDate = new Date(value);
    const dd = myDate.getUTCDate();
    const mm = myDate.getUTCMonth();
    const yyyy = myDate.getUTCFullYear();

    const dateFormat = moment(new Date(yyyy, mm, dd)).format("YYYY-MM-DD");

    return dateFormat;
  }
}


export function getMonthYear(month, year) {
  const today = new Date();
  const monthName = moment(new Date(year, (parseInt(month) - 1), 1)).format('MMM');
  const monthYear = monthName + " " + year;

  return monthYear;
}

//TODO: ver lo del undefined de la descripcion
export function resumeText30Chars(value) {
  if (value) {
    if (value.length <= 30) {
      return value;
    }
    return value.substring(0, 30) + "...";
  }
}

export function formatDateFromISO(value) {
  if (value) {

    if (isValidISODate(value)) {
      const myDate = new Date(value);
      const dd = myDate.getUTCDate();
      const mm = myDate.getUTCMonth();
      const yyyy = myDate.getUTCFullYear();

      return new Date(yyyy, mm, dd);
    } else {
      console.log("No pude identificar la fecha como válida: " + value)
      return value;
    }


  }
}

export function isValidISODate(str) {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z$/;
  console.log("isoDateRegex.test(str):" + (isoDateRegex.test(str)));
  return isoDateRegex.test(str);
}
